<template>
  <div class="site-width">
    <form-login
      ref="form"
      @submit="onFormSubmit"
      :loading="isProcessing"
      class="form form-login"
    />
  </div>
</template>
<script>
import Vue from 'vue';
import Component from 'vue-class-component';

import { mapActions } from 'vuex';
import FormLogin from '@/components/forms/FormLogin';

@Component({
  name: 'page-login',
  metaInfo: {
    title: 'Login',
    meta: [
      {
        vmid: 'Description',
        name: 'Description',
        content: 'Content',
      },
    ],
  },
  components: {
    FormLogin,
  },
  methods: mapActions(['userLogin']),
})
export default class PageLogin extends Vue {
  isProcessing = false;

  async onFormSubmit(userData) {
    this.isProcessing = true;
    try {
      const result = await this.userLogin(userData);
      if (result) {
        this.$router.push({ name: 'games' });
      } else {
        this.$refs.form.setError(this.$t('errors.wrong_credentials'));
      }
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.log(error);
      }
      this.$refs.form.setError(this.$t('errors.wrong_credentials'));
    }
    this.isProcessing = false;
  }
}
</script>
